<template>
  <div style="display: inline;">
    <yi_curd_table v-bind="$attrs" :name="$options.name" getUrl="/web/mixture/bom/page" ref="yt" getKey="rows" :columns="columns"> </yi_curd_table>
  </div>
</template>

<script>
export default {
  name: 'web_material_management_mixture_bom',
  props: {
    // 父组件传过来的参数
    mixtureOrderId: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      columns: [
        {
          label: 'wuliaobianma',
          prop: 'material.code'
        },
        {
          label: 'wuliaomingcheng',
          prop: 'material.name'
        },
        {
          label: 'guige',
          prop: 'material.spec'
        },
        {
          label: 'shuliang',
          prop: 'quantity'
        },
        {
          label: 'danwei',
          prop: 'unit'
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.conditions.mixtureOrderId = this.mixtureOrderId;
      this.yt.get(1);
    }, 300);
  }
};
</script>

<style scoped lang="scss"></style>
